<div class="ap-flex ap-flex-lt-lg-wrap ap-flex-gap-gt-md-2">
    <div class="ap-flex-basis-33 ap-flex-basis-lt-lg-100">
        <ng-container [ngTemplateOutlet]="header" [ngTemplateOutletContext]="{ contentKey: 'interest-rate-filters.amortisation-type' }">
        </ng-container>
        <ap-dropdown
            label="{{ 'interest-rate-filters.amortisation-type' | apContent }}"
            data-testid="amortisationType"
            [formControl]="amortisationType"
            [options]="amortisationTypeList"
        >
        </ap-dropdown>
    </div>
    <div class="ap-flex-basis-33 ap-flex-basis-lt-lg-100">
        <ng-container [ngTemplateOutlet]="header" [ngTemplateOutletContext]="{ contentKey: 'interest-rate-filters.fixed-rate-period' }">
        </ng-container>
        <ap-dropdown
            label="{{ 'interest-rate-filters.fixed-rate-period' | apContent }}"
            data-testid="fixedRatePeriod"
            [formControl]="fixedRatePeriod"
            [options]="fixedRatePeriodList"
        >
        </ap-dropdown>
    </div>
    <div class="ap-flex-basis-33 ap-flex-basis-lt-lg-100">
        <ng-container [ngTemplateOutlet]="header" [ngTemplateOutletContext]="{ contentKey: 'interest-rate-filters.energy-label' }">
        </ng-container>
        <ap-dropdown
            label="{{ 'interest-rate-filters.energy-label' | apContent }}"
            data-testid="energyLabel"
            [formControl]="energyLabel"
            [options]="energyLabelList"
        >
        </ap-dropdown>
    </div>
</div>

<ng-container [ngTemplateOutlet]="header" [ngTemplateOutletContext]="{ contentKey: 'interest-rate-filters.loan-to-value' }"> </ng-container>
<ltv-calculation class="ap-flex ap-flex-fill ap-margin-bottom-3" (setLoanToValue)="setLoanToValue($event)"></ltv-calculation>

<ap-chip-list typeChip="single">
    @for (loanToValue of loanToValueList; track $index) {
        <ap-chip
            [selected]="selectChip(loanToValue)"
            (selectionChange)="setLoanToValue(loanToValue)"
            aria-label="{{ loanToValue | loanToValuePipe | apContent }}"
            id="loanToValue-{{ loanToValue }}"
            >{{ loanToValue | loanToValuePipe | apContent }}</ap-chip
        >
    }
</ap-chip-list>

<ng-template #header let-contentKey="contentKey">
    <div class="ap-flex ap-flex-gap-2">
        <h2>{{ contentKey | apContent }}</h2>
        <ap-popover class="ap-margin-top-2" apAnalyticsClick elementType="icon" [key]="contentKey | apContent">
            <span ap-popover-parent>
                <ap-icon [id]="contentKey | apContent" name="help" size="large" color="secondary" aria-label="help icon"></ap-icon>
            </span>
            <ap-content ap-popover-content [key]="contentKey + '.hint'"></ap-content>
        </ap-popover>
    </div>
</ng-template>
